import { render, staticRenderFns } from "./nav_mobile.vue?vue&type=template&id=1c60391c&scoped=true&lang=pug&"
import script from "./nav_mobile.vue?vue&type=script&lang=js&"
export * from "./nav_mobile.vue?vue&type=script&lang=js&"
import style0 from "./nav_mobile.vue?vue&type=style&index=0&id=1c60391c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60391c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/Users/romzat/Sites/romza-web-2/components/Logo.vue').default})
